import { useEffect, useState } from 'react';
import { useTitle } from '../HooksPublic';
import { Button, Groupper, Header } from 'react-frontier';
import { Link, useParams } from 'react-router-dom';
import API from '../APIPublic';
import { PublicCareer } from '../ClassesPublic';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import { CDN_URL } from '../ConfigPublic';
import '../style/work_with_us.scss';


var CareerView = ()=>{
	var { id } = useParams<{ id: string }>();
	var { setTitle } = useTitle();
	var [career, setCareer] = useState<PublicCareer>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		if(!id) return;
		var career_id = parseInt(id);
		if(Number.isNaN(career_id)) return;

		setTitle('COCOAN - Vacante', false);
		API.getCareer(career_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setTitle(`COCOAN - ${res.data.title}`, false);
			setCareer(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error al cargar la vacante.');
		});
	}, [id]);

	var applyButton = career?.contact ? (
		<Button
			as='a'
			size='big'
			color='black'
			text='Aplicar aquí'
			className='apply-btn'
			href={`mailto:${career.contact}?subject=${encodeURIComponent(`Postulación - ${career.title}`)}`}
		/>
	) : null;

	return <div className='co work-with-us-screen'>
		{career && !loadError && (
			<div className='work-hero'>
				<img src={`${CDN_URL}/static/work_with_us/BANNER_TRABAJO.webp`} alt={career.title} className='hero-bg' />
				<div className="hero-overlay">
					<h1>{career.title}</h1>
				</div>
			</div>
		)}
		<div className='career-detail-container'>
			<Link className='back-link' to='/vacantes'>{'< Atrás'}</Link>
			{loadError ? (
				<Header text='Error' subtext={loadError} />
			) : !career ? (
				<Header loading text='Cargando' />
			) : (
				<div className="career-content-box">
					<div className="career-description-col">
						<h2>Funciones del puesto</h2>
						{career.description && (
							<div className='description'>
								<ReactMarkdown>{career.description}</ReactMarkdown>
							</div>
						)}
					</div>
					<div className="career-action-col">
						{applyButton}
					</div>
				</div>
			)}
		</div>
	</div>;
};

export default CareerView;
